<template>
  <file-uploader :url="url"
    :single="false"
    :name="name"
    :max-file-size="500"
    :params="params"
    :ref="multiFileRef"
    :transmit-ref="transmitRef"
    v-bind="options"

    @processing="handleProcessing"
    @success="handleSuccess"
    @error="handleError">

    <div class="row">
      <div class="col">
         <b-button variant="primary" :block="true" @click="triggerBrowse">
            Subir arquivo
        </b-button>
      </div>
    </div>

    <template slot="files" slot-scope="props">
      <slot name="files" :files="props">
        <div class="clearfix w-100">
          <div v-for="(file, i) in props.files" :key="file.id" :class="{'w-100': i === 0}">
            <div v-show="file.upload.progress < 100">
              <div class="clearfix">
                <div class="float-left">
                  <strong>{{ file.upload.progress | fixed(2) }}%</strong>
                </div>

                <div class="float-right">
                  <small class="text-muted">{{ file.upload.speed.kbps  | fixed(2) }} kbps</small>
                </div>
              </div>

              <b-progress height={} class="progress-xs" v-model="file.upload.progress" variant="primary">
                <!-- // -->
              </b-progress>

              <div class="float-right" v-if="processing && success">
                <small class="text-muted">
                  Upload feito com sucesso!
                </small>
              </div>
            </div>
          </div>
        </div>
      </slot>
    </template>
  </file-uploader>
</template>

<script>
  import { assign, isEmpty } from 'lodash'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    data () {
      return {
        processing: false,
        success: false,

        transmitRef: '',

        multiFileOptions: {
          dragClass: 'dragging',
          acceptedFileTypes: ['*'],
          clickable: false
        }
      }
    },

    props: {
      url: {
        type: String,
        required: true
      },

      name: {
        type: String,
        default: 'file'
      },

      multiFileRef: {
        type: String,
        default: 'SingleFileRef'
      },

      placeholder: {
        type: Object,
        default: () => {}
      },

      collection: {
        type: String,
        default: 'default'
      },

      fields: {
        type: Object,
        default: () => {}
      },

      items: {
        type: Array,
        default: () => []
      }
    },

    computed: {
      ...mapGetters({
        getError: 'errors/getError',
        hasError: 'errors/hasError'
      }),

      emptyValue () {
        return isEmpty(this.value)
      },

      options () {
        return assign(this.multiFileOptions, {
          url: this.url
        })
      },

      params () {
        return assign(this.fields, {
          collection: this.collection
        })
      }
    },

    methods: {
      ...mapActions({
        clearError: 'errors/clearError'
      }),

      triggerBrowse () {
        if (this.processing === false) {
          this.$refs[this.multiFileRef]
            .$refs[this.transmitRef]
            .triggerBrowseFiles()
        }
      },

      handleSuccess () {
        this.$nextTick(() => {
          this.clearError([this.name])
          this.processing = false
          this.success = true
        })

        this.$emit('success', arguments[0], arguments[1], arguments[2])
      },

      handleError () {
        this.$nextTick(() => { this.processing = false })

        this.$emit('error', arguments[0], arguments[1], arguments[2])
      },

      handleProcessing () {
        this.processing = true
        this.clearError([this.name])

        this.$emit('processing', arguments[0])
      }
    },

    filters: {
      fixed (value, n) {
        return Number.parseFloat(value).toFixed(n || 2)
      },

      json (value) {
        return JSON.stringify(value, null, 2)
      }
    },

    created () {
      this.transmitRef = this.multiFileRef + Math.random().toString(36).substr(2, 5)
    }
  }
</script>

<style lang="sass">
  i.clickable
    cursor: pointer

    &.fa-trash-o:hover
      color: #7c0f1a

  .v-transmit__upload-area
    height: 100px

    &.v-transmit__upload-area--is-dragging
      border: 2px dotted #d7d7d7
      background-color: #e7e7e7

  .alert-danger
    color: #813838
    background-color: #fee2e1
    border-color: #fdd6d6
</style>



// WEBPACK FOOTER //
// src/components/ui/MultipleFileInput.vue